import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonTopicParams } from "../../../Pages/VideoLessonsDashboard/topic/IVideoLessonDashboard";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = VideoLessonTopicParams;

export const ListVideoTopicSlice = createSlice({
  name: "ListVideoTopicSlice",
  initialState: {} as IReduxState<IVideoTopic[]>,
  reducers: {
    listVideoTopic: (state, action) => {
      state.isLoading = true;
    },

    successListVideoTopic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListVideoTopic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { listVideoTopic, successListVideoTopic, failureListVideoTopic } =
  ListVideoTopicSlice.actions;

export default ListVideoTopicSlice.reducer;
